import { render, staticRenderFns } from "./modalEmployeeProgram.vue?vue&type=template&id=70f7a368&"
import script from "./modalEmployeeProgram.vue?vue&type=script&lang=js&"
export * from "./modalEmployeeProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports